export const aboutMe = {
    "hinttext": "Wer bin ich?\n" +
        "Was macht meine Persönlichkeit aus?\n" +
        "Was sind meine Werte?\n" +
        "Auf was lege ich besonders Wert in der Erziehung?\n" +
        "Welche Besonderheiten hat mein Kind (Allergien, Einschränkungen, Interessen)?\n" +
        "Was ist mir bei der Betreuung  besonders wichtig?\n" +
        "Lieblingsbücher/Lieblingsmusik?\n" +
        "Sonstige Interessen?"
}